import { render, staticRenderFns } from "./RangeQuestion.vue?vue&type=template&id=6a204c0c&scoped=true&"
import script from "./RangeQuestion.vue?vue&type=script&lang=js&"
export * from "./RangeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RangeQuestion.vue?vue&type=style&index=0&id=6a204c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a204c0c",
  null
  
)

export default component.exports